<!-- Step 2 - Choose bank -->
<!--<p class="text-label">{{$t('income.choose-bank.label')}}</p>
<div class="select-container">
    <select>
        <option value="">{{ $t('generic.choose.label') }}</option>
    </select>
    <span class="icon">
        <SvgIcon icon="select-arrow" />
    </span>
</div>-->

<template>
    <div>
        <h2>{{$t('screening-upload.income.headline')}}</h2>
        <p class="text">{{$t('screening-upload.income.description')}}</p>

        <div class="seperator"></div>

        <div class="icome-content">
            <!-- Vælg mellem automatisk og manuel -->
            <div class="step-content" v-if="!choosedAutomatic && !choosedManually && !getNordicApiToken">
                <!-- <div v-model="choosedAutomatic" @click="chooseAutomatic">
                    <ChooseBox>
                        <SvgIcon slot="icon" icon="automatic"></SvgIcon>
                        <span slot="headline">{{$t('income.automatic.headline')}}</span>
                        <span slot="text">{{$t('income.automatic.text')}}</span>
                    </ChooseBox>
                </div> -->
                <div v-model="choosedManually" @click="chooseManually">
                    <ChooseBox>
                        <SvgIcon slot="icon" icon="manually"></SvgIcon>
                        <span slot="headline">{{$t('income.manually.headline')}}</span>
                        <span slot="text">{{$t('income.manually.text')}}</span>
                    </ChooseBox>
                </div>
            </div>
            <div v-if="choosedAutomatic || getNordicApiToken" class="step-content">
                <h3>{{$t('automatic.step.headline')}}</h3>
                <InfoBoxSecurity />
                <button
                    class="purple"
                    v-if="!getNordicApiToken"
                    :disabled="openingBankScreen"
                    v-on:click="openBankScreen();">{{ $t('nordicapi.open-gateway.button') }}</button>

                <StatementSelector v-if="getNordicApiToken" v-on:viewaccountid="receive" />
            </div>
        </div>

        <div v-if="choosedManually">
           <div v-if="uploadedFile" class="uploaded-item">
                <div class="file-name">{{uploadedFile.file_name}}</div>
                <div class="delete-item" @click.prevent="deleteFile"><img src="/images/SVG/Delete.svg"></div>
            </div>
            <div v-else>
                <vue-dropzone class="income" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                  @vdropzone-success="uploadSuccess"
                  @vdropzone-sending="sendingFiles"
                  @vdropzone-error="customUploadError"
                  ></vue-dropzone>
            </div>
       </div>

        <div class="seperator"></div>

        <a class="purple button" href="#review"
            v-on:click="incomeDone"
            v-if="(choosedManually)
            ||
                    (!choosedManually && (getNordicApiToken))"
                :disabled="getNordicApiToken && !viewAccountId"
                >
                {{$t(choosedAutomatic || getNordicApiToken ? 'button.nordicapi-continue-logout' : 'button.continue')}}
            </a>
       <a class="back-link" v-on:click="back()" v-if="choosedManually || choosedAutomatic || getNordicApiToken">
                <SvgIcon icon="small-arrow-left"></SvgIcon>
                {{$t('button.back.label')}}
            </a>

    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import ChooseBox from '../../../components/ChooseBox.vue';
    import InfoBoxSecurity from '../../../components/InfoBoxSecurity.vue';
    import SelectBox from '../../../components/SelectBox.vue';
    import Loader from '../../../components/Loader.vue';
    import SvgIcon from '../../../components/Svg.vue';
    import StatementSelector from '../../../components/NordicApi/StatementSelector.vue';

    export default {
        components: {
            vueDropzone: vue2Dropzone,
            ChooseBox,
            InfoBoxSecurity,
            SelectBox,
            Loader,
            SvgIcon,
            StatementSelector
        },
        props: [
            'value'
        ],
        data: () => ({
            dropzoneOptions: {},
            type: 'income',
            uploadedFile: '',
            choosedAutomatic: false,
            choosedManually: false,
            openStatementSelector: false,
            openingBankScreen: false,
            viewAccountId: false
        }),
        computed:{
            ...mapGetters([
                'getToken',
                'getIncomeFile',
                'getNordicApiToken'
            ]),
            income: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            receive(value) {
                this.viewAccountId = value;
            },
            incomeDone() {
                this.$emit('complete');
                this.back();
            },
            back() {
                this.choosedManually = false;
                this.choosedAutomatic = false;
                this.logout();
            },
            openBankScreen() {
                return;
                this.openingBankScreen = true;
                axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/nordicapi/initialize',

                }).then(response => {
                    this.openingBankScreen = false;
                    location.href = response.data.authUrl;
                }).finally(e => {
                    this.openingBankScreen = false;
                });
            },
            customUploadError(data) {
                if(data.xhr !== null && (data.xhr.status === 401 || data.xhr.status === 403)) {
                    this.$store.commit('setToken', null)
                    return;
                }

                if (typeof data.xhr == 'undefined') {
                    this.$swal(this.$t('general.unknown-error.label'), [], 'error');

                    return;
                }
                let response = JSON.parse(data.xhr.responseText);
                this.$swal(response.message, [], 'error');
                this.$refs.myVueDropzone.removeAllFiles();
            },
            isFilled() {
                return this.uploadedFile || this.value ? true : false;
            },


            chooseAutomatic: function(){

                this.choosedAutomatic = !this.choosedAutomatic
            },
            chooseManually: function(){

                this.choosedManually = !this.choosedManually
            },
            uploadSuccess(file, response){
                this.uploadedFile = response;
                this.$root.$emit('tab', 'rkiStatus', false);
                this.$root.$emit('tab', 'occupation', false);
                this.$store.dispatch('fetchScreeningStatus');
                this.$root.$emit('refreshScreeningStatus');
            },
            sendingFiles(file, xhr, formData){
                formData.append('type', this.type);
            },
            deleteFile(){
                axios({
                    method: 'DELETE',
                    url: window.config.apiUrl + 'api/user/document/' + this.uploadedFile.id,

                }).then(
                    () => {
                        this.uploadedFile = '';
                        this.$store.dispatch('fetchScreeningStatus');
                    }
                );
            },
            logout() {
                this.$store.commit('setNordicApiToken', false);
                this.$router.push('/tenant-screening#income');
            }
        },
        created(){
            this.$store.dispatch('fetchIncomeFile').then(
                () => {
                    this.uploadedFile = this.getIncomeFile[0];
                    if(this.uploadedFile){
                        this.$root.$emit('tab', 'rkiStatus', false);
                        this.$root.$emit('tab', 'occupation', false);
                    }
                }
            );
            this.dropzoneOptions = {
                url: window.config.apiUrl + 'api/user/document',
                thumbnailWidth: 150,
                maxFilesize: 10,
                paramName: 'file',
                headers: {
                    'Authorization': 'Bearer ' + this.getToken
                },
                autoProcessQueue: true,
                dictDefaultMessage: '',
                uploadMultiple: false,
            };
            this.dropzoneOptions.dictDefaultMessage = this.$t('label.upload.placeholder');

            this.$on('viewAccountId', (value)=>{
                this.viewAccountId=value;

            })
        }
    }
</script>

<style scoped>

</style>
